// extracted by mini-css-extract-plugin
export default {"item":"tabCommon_item__3sygm"};